import { Capacitor } from '@capacitor/core'
import { Haptics, ImpactStyle } from '@capacitor/haptics'
import { log, reason } from '../app/log.js'
import { sfx } from '../audio/bus.js'

/**
 * POLISH §3 POL-01, POL-14, POL-15: every press answers with a sound and, on a native build, a
 * light haptic. One helper so no lane wires its own. Both channels are best effort: audio does
 * nothing before the first gesture unlocks the context, and haptics no op on the web.
 */

const logger = log('feedback')

export type FeedbackWeight = 'tap' | 'reward' | 'success'

const SFX: Record<FeedbackWeight, string> = {
  tap: 'tap',
  reward: 'reward',
  success: 'level-up',
}

const IMPACT: Record<FeedbackWeight, ImpactStyle> = {
  tap: ImpactStyle.Light,
  reward: ImpactStyle.Medium,
  success: ImpactStyle.Heavy,
}

export function feedback(weight: FeedbackWeight = 'tap'): void {
  sfx(SFX[weight])
  if (!Capacitor.isNativePlatform()) return
  Haptics.impact({ style: IMPACT[weight] }).catch((error) => {
    // A device without a taptic engine is not a failure worth surfacing.
    logger.debug('haptics declined', reason(error))
  })
}
